import { faCircleNotch, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BottomSheet from "components/reusable/BottomSheet";
import AuthContext from "context/AuthContext";
import { Button } from "flowbite-react";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { apiPost } from "utils/apiFetch";
import pathObj from "utils/apiPath";
import "./MyCards.css";

function NewCard({ onNewCard }) {
  const { t } = useTranslation();
  const notification = useToastContext();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });

  const [loading, setLoading] = useState(false);
  const [showNewCardBottomSheet, setShowNewCardBottomSheet] = useState(false);

  const preventSpace = (e) => {
    e.target.value = e.target.value.trim();
  };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await apiPost(pathObj.addCard, {
        cardholderName: `${user.first_name} ${user.last_name}`,
        cardNumber: data.card_number.replaceAll(" ", ""),
        expirationDate: data.card_expiry.replaceAll("/", ""),
        cvv: data.cvv,
      });

      if (response.data.success) {
        setShowNewCardBottomSheet(false);
        notification.success(response.data.message);
        onNewCard();
      } else {
        notification.error(response.data.message);
      }
    } catch (err) {}
    setLoading(false);
  };

  return (
    <>
      <div class={`snap-center shrink-0 w-full`}>
        <div
          className="bg-card rounded-2xl mx-1 text-white p-[1rem] border-2 cursor-pointer border-dashed border-gray-400 dark:border-gray-600 flex h-full items-center justify-center"
          onClick={() => {
            setShowNewCardBottomSheet(true);
          }}
        >
          <Button className="bg-card p-4 gap-2 items-center flex rounded-2xl">
            <FontAwesomeIcon icon={faPlus} className="card-icon" />
            <span className="font-medium text-base">{t("NEW_CARD")}</span>
          </Button>
        </div>
      </div>
      {showNewCardBottomSheet && (
        <BottomSheet open={showNewCardBottomSheet} onClose={() => {
            setShowNewCardBottomSheet(false)
        }} title={t("NEW_CARD")}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              type="text"
              id="card_number"
              placeholder={t("CARD_NUMBER")}
              className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body mt-3"
              onKeyDown={(e) => {
                e.target.value = (e.target.value.replaceAll(" ", "").match(/.{1,4}/g) || []).join(" ");
              }}
              {...register("card_number", {})}
              required
            />
            <div className="grid grid-cols-2 mt-3 gap-2">
              <div className="col-span-1">
                <input
                  type="text"
                  id="card_expiry"
                  placeholder="MM/VV"
                  className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  required
                  maxLength={5}
                  onKeyDown={(e) => {
                    e.target.value = (e.target.value.replaceAll("/", "").match(/.{1,2}/g) || []).join("/");
                  }}
                  {...register("card_expiry", {})}
                />
              </div>
              <div className="col-span-1">
                <input
                  type="number"
                  id="cvv"
                  placeholder="CVV"
                  maxLength={4}
                  className="inputform text-heading text-sm rounded-base block w-full px-3 py-2.5 shadow-xs placeholder:text-body"
                  required
                  {...register("cvv", {})}
                />
              </div>
            </div>
            <div className="w-full mt-5">
              {loading ? (
                <div className="btn btn_theme w-full flex items-center justify-center p-3">
                  <FontAwesomeIcon icon={faCircleNotch} className="text-white text-xl animate-spin" />
                </div>
              ) : (
                <button className="btn btn_theme w-full text-white" type="submit">
                  {t("SAVE_CARD")}
                </button>
              )}
            </div>
          </form>
        </BottomSheet>
      )}
    </>
  );
}

export default NewCard;
